import React, { useState, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ThreadList from '../components/messages/ThreadList';
import MessageThread from '../components/messages/MessageThread';
import NotificationBell from '../components/notifications/NotificationBell';

const MessagesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeThreadId, setActiveThreadId] = useState(null);
  const [activeThreadTitle, setActiveThreadTitle] = useState('');

  // "Discuss" from an expense/activity/swap navigates here with ?thread=<id>.
  // Reading it into state on mount (and on any later param change) is what lets
  // those buttons land the user directly in the right conversation.
  const threadParam = searchParams.get('thread');
  useEffect(() => {
    if (threadParam && threadParam !== activeThreadId) {
      setActiveThreadId(threadParam);
      setActiveThreadTitle('');
    }
  }, [threadParam]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectThread = useCallback((threadId, title) => {
    setActiveThreadId(threadId);
    setActiveThreadTitle(title);
    // Keep the URL in step so the open conversation survives a refresh and can
    // be linked to directly. `replace` avoids stacking a history entry per
    // thread click, which would make Back feel broken.
    setSearchParams(threadId ? { thread: threadId } : {}, { replace: true });
  }, [setSearchParams]);

  return (
    <div className="animate-fade-in">
      <div className="flex items-center justify-between page-header">
        <div>
          <h1 className="page-title">Messages</h1>
          <p className="page-subtitle">Communicate with your co-parent</p>
        </div>
        <NotificationBell />
      </div>

      <div className="card overflow-hidden" style={{ height: 'calc(100vh - 220px)' }}>
        <div className="flex h-full">
          {/* Thread list sidebar */}
          <div className="w-80 border-r border-surface-100 flex-shrink-0">
            <ThreadList
              activeThreadId={activeThreadId}
              onSelectThread={handleSelectThread}
            />
          </div>

          {/* Active thread */}
          <div className="flex-1">
            <MessageThread
              threadId={activeThreadId}
              threadTitle={activeThreadTitle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagesPage;
